import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

const getEventTrackerHook = <T extends TrackEventBaseParameters>(
    trackFunction: (parameters: T, options?: Toolkit.GoogleAnalytics.Options) => void,
    parameters: Partial<T> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters = {
        ...ga.use.eventParameters(options),
        ...parameters,
    } as T;

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        skipOptionItems: true,
        ...options,
    };

    return (parameters: Partial<T> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return trackFunction({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default getEventTrackerHook;
